export const container = `relative bg-base-white w-full h-screen flex flex-col`;
export const header = `w-full flex items-center mb-4 gap-4 flex-row-reverse md:flex-row`;
